import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgConfirmActionUrl from '@/assets/misc/img_confirm-action.svg'
import WorkspaceRolesIllustration from '@/components/SpotIllustration/WorkspaceRolesIllustration'

export interface RejectMergeDialogProps {
  showing: boolean
  onClose: () => unknown
  onReject: () => unknown
  isRejectPending: boolean
  customerDisplayName: string
}

export function RejectMergeDialog({
  showing,
  onClose,
  onReject,
  isRejectPending,
  customerDisplayName,
}: RejectMergeDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isRejectPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgConfirmActionUrl}
            illustration={byDesign(undefined, WorkspaceRolesIllustration)}
            alt="Illustration of a confused person with a question mark bubble above their head"
          />
          <ModalSheetContentTitle>
            You're about to decline this merge request
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            If you decline, we will notify{' '}
            <strong>{customerDisplayName}</strong> that we will take no further
            action against their account.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            isDisabled={isRejectPending}
            onPress={onClose}
          />
          <Button
            label="Decline Merge"
            isDisabled={isRejectPending}
            variant="destructive"
            onPress={onReject}
            isPending={isRejectPending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
